import { tickerItems } from "@/mocks/site";

export default function TickerBar() {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="w-full border-y border-primary-700/40 bg-primary-600">
      <div className="flex items-center">
        <span className="flex shrink-0 items-center gap-2 bg-primary-700 px-4 py-3 font-label text-xs tracking-widest text-background-50 md:px-6">
          <i className="ri-alarm-warning-line text-base leading-none text-accent-400"></i>
          今日速报
        </span>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex w-max animate-marquee items-center">
            {loop.map((text, index) => (
              <span key={`${text}-${index}`} className="flex items-center gap-3 whitespace-nowrap px-6 font-label text-xs text-background-50/90 md:text-sm">
                <i className="ri-arrow-right-s-line text-base leading-none text-accent-400"></i>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}